import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
  selector: '[mediaLibraryTableDirective]',
})
export class MediaLibraryTableDirective {
  constructor(public viewContainerRef: ViewContainerRef) { }
}